import { render, staticRenderFns } from "./BuyPhones.vue?vue&type=template&id=560d6f6b&"
import script from "./BuyPhones.vue?vue&type=script&lang=js&"
export * from "./BuyPhones.vue?vue&type=script&lang=js&"
import style0 from "./BuyPhones.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
